import script from "./TopicBox.vue?vue&type=script&setup=true&lang=js"
export * from "./TopicBox.vue?vue&type=script&setup=true&lang=js"

import "./TopicBox.vue?vue&type=style&index=0&id=6b33794e&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b33794e"]])

export default __exports__